/**
 * CRM/Sales User Settings Form
 * User preferences for sales module, including data export/import
 */
import { useTranslation } from 'react-i18next';
import { ExportImportSection } from '../../../shared/components/common/ExportImportSection';

interface CrmUserSettingsFormProps {
  onSuccess?: () => void;
}

export function CrmUserSettingsForm({ onSuccess: _onSuccess }: CrmUserSettingsFormProps) {
  const { t } = useTranslation(['pipeline', 'common']);

  const formatEntityCounts = (counts: Record<string, number>): string => {
    const parts: string[] = [];
    if (counts.pipelines) parts.push(`${counts.pipelines} ${t('pipeline:exportImport.pipelines')}`);
    if (counts.companies) parts.push(`${counts.companies} ${t('pipeline:exportImport.companies')}`);
    if (counts.contacts) parts.push(`${counts.contacts} ${t('pipeline:exportImport.contacts')}`);
    if (counts.deals) parts.push(`${counts.deals} ${t('pipeline:exportImport.deals')}`);
    return parts.join(', ');
  };

  return (
    <div className="space-y-4">
      <p className="text-sm text-muted-foreground">
        {t('pipeline:settings.description', 'Manage your sales data and preferences.')}
      </p>
      <ExportImportSection
        moduleName="pipeline"
        i18nNamespace="pipeline"
        invalidateKeys={[['pipelines'], ['organizations'], ['contacts'], ['deals']]}
        formatEntityCounts={formatEntityCounts}
      />
    </div>
  );
}
